import some from 'lodash/some';

type Predicate<T> = (value: T) => boolean;
type Predicates<T> = Record<any , Predicate<any>>;

// Similar to lodash's `conforms` function. Returning **true** if one of predicates return truthy, else **false**
export function conformsOne<T>(obj: T, predicates: Predicates<T>): boolean {
    return some(predicates, (predicate, key) => predicate(obj[key]));
}
